import React from 'react'
import Cardetails from '../components/Cardetails'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const CarddetailsPage = () => {
  return (
    <div>
      
      <Cardetails/>
      <Footer/>
    </div>
  )
}

export default CarddetailsPage
